import questionsData from "../../data/questionlist.json";

export const LOAD_QUESTIONS = "LOAD_QUESTIONS";
export const SUBMIT_ANSWER = "SUBMIT_ANSWER";
export const NEXT_QUESTION = "NEXT_QUESTION";
export const PREVIOUS_QUESTION = "PREVIOUS_QUESTION";
export const DECREMENT_TIMER = "DECREMENT_TIMER";
export const END_ASSESSMENT = "END_ASSESSMENT";
export const RESET_QUIZ = "RESET_QUIZ";
export const Start_ASSESSMENT = "Start_ASSESSMENT";
export const CHECKINTIME = "CHECKINTIME";
export const AUTOLOGIN = "AUTOLOGIN";

export const loadQuestions = () => (dispatch) => {
  dispatch({
    type: LOAD_QUESTIONS,
    payload: questionsData,
  });
};

export const Startassesment = (start) => (dispatch) => {
  dispatch({
    type: Start_ASSESSMENT,
    payload: start,
  });
};

export const AutoLogin = (data) => {
  return {
    type: 'AUTOLOGIN',
    payload: data,
  };
};

export const submitAnswer = (questionIndex, answer) => ({
  type: SUBMIT_ANSWER,
  payload: { questionIndex, answer },
});

export const resetQuiz = () => ({
  type: RESET_QUIZ,
});

export const nextQuestion = () => ({ type: NEXT_QUESTION });
export const previousQuestion = () => ({ type: PREVIOUS_QUESTION });
export const decrementTimer = () => ({ type: DECREMENT_TIMER });
export const endAssessment = () => ({ type: END_ASSESSMENT });
